/**
 * Grievance Form Specific Options
 */

// Query Type Options for Grievance
export const GRIEVANCE_QUERY_TYPE_OPTIONS = [
  { value: 'status-loan-application-top-up', label: 'Status Loan Application/ Top Up' },
  { value: 'disbursement-of-loan', label: 'Disbursement of Loan' },
  { value: 'builder-subvention', label: 'Builder Subvention' },
  { value: 'document-related', label: 'Document Related' },
  { value: 'pmay-subsidy-related', label: 'PMAY Subsidy Related' },
  { value: 'closure-of-loan', label: 'Closure of Loan' },
  { value: 'refund-related', label: 'Refund Related' },
  { value: 'repayment-related-emi-pemi', label: 'Re-payment Related (EMI/PEMI)' },
  { value: 'part-payment', label: 'Part Payment' },
  { value: 'rate-of-interest', label: 'Rate of Interest' },
  { value: 'cibil-related', label: 'CIBIL Related' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'tds-related', label: 'TDS Related' },
  { value: 'gst-invoice', label: 'GST Invoice' },
  { value: 'service-related', label: 'Service Related' },
  { value: 'address-contact-updation', label: 'Address/Contact Updation' },
  { value: 'loan-account-related', label: 'Loan Account Related' }
];

// Citizenship Options
export const CITIZENSHIP_OPTIONS = [
  { value: 'indian', label: 'Indian' },
  { value: 'nri', label: 'NRI' }
];
